// INDEX
export const ROOT = '';
export const INDEX = '/';
export const NOT_FOUND = '/404';
export const OFFER_T2 = '/docs/Оферта Т2.pdf'
export const OFFER_RNKO = '/docs/Оферта РНКО.pdf'
export const OFFER_ITK = '/docs/Оферта_Правила_абоненткого_обслуживания_Забота_о_здоровье_Т2.pdf'
export const OFFER_POLICY = '/docs/Политика ПД.pdf'